import baseApi, {
    transformResponseFromData,
    // transformResponseFromMessage,
    // provideTags,
    // provideTag,
} from 'store/slices/api/baseApi'

const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCurrentUser: build.query({
            query: () => ({
                url: `auth/getCurrentUser`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: ['CurrentUser'],
        }),
        login: build.mutation({
            query: ({email, password}) => {
                return {
                    url: `auth/login`,
                    method: 'POST',
                    body: {email, password},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        logout: build.mutation({
            query: () => ({
                url: `auth/logout`,
                method: 'POST',
            }),
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser,Profile'],
        }),
        signup: build.mutation({
            query: (query) => {
                return {
                    url: `auth/signup`,
                    method: 'POST',
                    body: query,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        forgotPassword: build.mutation({
            query: ({email}) => {
                return {
                    url: `auth/forgotPassword`,
                    method: 'POST',
                    body: {email},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
        resetPassword: build.mutation({
            query: ({password, token}) => {
                return {
                    url: `auth/resetPassword`,
                    method: 'POST',
                    body: {password, token},
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: ['CurrentUser'],
        }),
    }),
    overrideExisting: false,
})

export default authApi

export const {
    useLoginMutation,
    useGetCurrentUserQuery,
    useLogoutMutation,
    useSignupMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    // useGetUsersQuery,
    // useGetUserQuery,
    // useGetVersionsQuery,
    // useStatsQuery,
    // useUpdateVersionsMutation,
} = authApi
